(() => {
  'use strict';

  const tiers = [
    { quantity: 1, bundlePrice: 30, unitPrice: '$30.00', unitPriceAmount: 30 },
    { quantity: 2, bundlePrice: 54, unitPrice: '$27.00', unitPriceAmount: 27 },
    { quantity: 3, bundlePrice: 81, unitPrice: '$27.00', unitPriceAmount: 27 },
    { quantity: 4, bundlePrice: 99, unitPrice: '$24.75', unitPriceAmount: 24.75 },
    { quantity: 6, bundlePrice: 132, unitPrice: '$22.00', unitPriceAmount: 22 },
    { quantity: 8, bundlePrice: 160, unitPrice: '$20.00', unitPriceAmount: 20 },
  ];
  // AU Online Store net items sold to Australian shipping addresses, 6 Jul–3 Oct 2026.
  const retailFlavours = [
    { productId: '7967584256047', variantId: '43799941840943', handle: 'dubai-chocolate-crunch-jar', name: 'Dubai Chocolate' },
    { productId: '8507706245167', variantId: '46880745979951', handle: 'coconut-almond-cream-crunch-jar-350g', name: 'Coconut Almond Cream' },
    { productId: '8126738563119', variantId: '44762426638383', handle: 'bueno-crunch-jar-l-350g', name: 'Bueno Crunch' },
    { productId: '8274565136431', variantId: '45376606699567', handle: 'loaded-hazelnut-crunch-jar-350g', name: 'Loaded Hazelnut' },
    { productId: '8117831761967', variantId: '44733413261359', handle: 'cookies-cream-crunch-jar-350g', name: 'Cookies & Cream' },
    { productId: '8377641074735', variantId: '45659472920623', handle: 'caramelised-white-choc-crunch-jar-350g', name: 'Caramelised White Choc' },
    { productId: '8333292240943', variantId: '45566300684335', handle: 'choc-wafer-crunch-jar-350g', name: 'Choc Wafer' },
    { productId: '8117831663663', variantId: '44733412900911', handle: 'cookie-butter-crunch-jar-350g', name: 'Cookie Butter' },
    { productId: '8172018204719', variantId: '44955196293167', handle: 'strawberries-cream-crunch-jar', name: 'Strawberries & Cream' },
    { productId: '8201138864175', variantId: '45052343975983', handle: 'bueno-crunch-jar-l-350g-copy-1', name: 'Peanut Butter Cup' },
    { productId: '8244380762159', variantId: '45234696486959', handle: 'taro-crunch-jar-350g', name: 'Taro' },
    { productId: '8434038931503', variantId: '45870554284079', handle: 'cinnamon-scroll-crunch-jar-350g', name: 'Cinnamon Scroll' },
    { productId: '8224720224303', variantId: '45158488277039', handle: 'dark-choc-crunch-jar-l-350g', name: 'Dark Choc' },
    { productId: '8401909088303', variantId: '45736392753199', handle: 'mango-cream-crunch-jar-350g', name: 'Mango Cream' },
    { productId: '8477382803503', variantId: '46191655321647', handle: 'choc-buttons-crunch-jar-350g', name: 'Choc Buttons' },
  ];
  const retailFlavourByVariant = new Map(retailFlavours.map((flavour, rank) => [flavour.variantId, { ...flavour, rank }]));
  const maximumQuantity = 8;
  let bundleRoot;
  let bundleObserver;
  let bundleSourceSection;
  let renderQueued = false;
  let lastCount = -1;
  let selectedTierQuantity = null;
  let tierPanelCollapsed = false;
  let selectionRevision = 0;
  let selectionRebaseInProgress = false;
  let celebrationTimer;
  const celebratedTiers = new Set();

  function isLaunchProductPage() {
    return Boolean(bundleRoot?.closest('.cj-au-launch-product-bundle-wrapper'));
  }

  function isSingleJarPage() {
    return isLaunchProductPage() && !bundleRoot.closest('.cj-au-essenify-parent');
  }

  function getRetailFlavour(card) {
    const link = card.querySelector('.essenify-mam-product-title a');
    const variantId = card.querySelector('.essenify-mam-variant-select option')?.value?.replace(/\D/g, '');
    const handle = link?.getAttribute('href')?.split('/products/')[1]?.split(/[?#]/)[0];
    const flavour = retailFlavourByVariant.get(variantId);
    return flavour?.handle === handle ? flavour : null;
  }

  function isCardUnavailable(card) {
    return card.dataset.cjProductAvailable === 'false'
      || Boolean(card.querySelector('.essenify-mam-variant-select option:checked, .essenify-mam-variant-select option')?.disabled);
  }

  function sortRetailCards() {
    const grid = bundleRoot?.querySelector('#essenify-mam-products-grid');
    const cards = [...(grid?.querySelectorAll(':scope > .essenify-mam-product-card') || [])];
    // The shared app record is updated after the compatible theme is published.
    // Accept the complete prior catalogue only while Coconut is still absent.
    if (!grid || ![retailFlavours.length - 1, retailFlavours.length].includes(cards.length)
      || grid.children.length !== cards.length) return false;

    const seen = new Set();
    for (const card of cards) {
      const flavour = getRetailFlavour(card);
      if (!flavour || seen.has(flavour.variantId)) return false;
      seen.add(flavour.variantId);
    }

    if (cards.length === retailFlavours.length - 1 && seen.has('46880745979951')) return false;

    const ordered = cards.sort((a, b) =>
      Number(isCardUnavailable(a)) - Number(isCardUnavailable(b))
      || getRetailFlavour(a).rank - getRetailFlavour(b).rank);
    if (ordered.some((card, index) => grid.children[index] !== card)) {
      ordered.forEach((card) => grid.append(card));
    }
    return true;
  }

  function positionLaunchProductBundle(retailCardsReady) {
    if (!isLaunchProductPage()) return;

    const host = bundleRoot.closest('.cj-au-bundle-host');
    const productInfo = document.querySelector('.product__info-container');
    if (!host || !productInfo) return;

    const title = productInfo.querySelector('.product__title');
    const description = productInfo.querySelector('.product__description');
    const reviews = productInfo.querySelector('[id*="vitals_reviews_stars"]');

    if (title && description && title.nextElementSibling !== description) {
      title.after(description);
    }

    if (description && reviews && description.nextElementSibling !== reviews) {
      description.after(reviews);
    }

    const anchor = reviews || description || title;
    if (anchor && anchor.nextElementSibling !== host) {
      anchor.after(host);
    } else if (!anchor && host.parentElement !== productInfo) {
      productInfo.prepend(host);
    }

    if (
      !retailCardsReady
      || (isSingleJarPage() && !getCurrentProductCard())
      || (bundleRoot.querySelector('.essenify-mam-rules-mobile')?.querySelectorAll('.essenify-mam-rule-block').length || 0) < tiers.length
      || !bundleRoot.querySelector('#essenify-mam-submit')
    ) {
      host.hidden = true;
      document.body.classList.remove('cj-au-essenify-ready');
      if (bundleSourceSection) bundleSourceSection.hidden = false;
      return;
    }

    host.hidden = false;
    document.body.classList.add('cj-au-essenify-ready');

    const productSection = productInfo.closest('.shopify-section');
    if (bundleSourceSection && bundleSourceSection !== productSection) {
      bundleSourceSection.hidden = true;
    }
  }

  function getAvailableTiers() {
    const singleJarPage = isSingleJarPage();
    return tiers.filter((tier) => !singleJarPage || tier.quantity !== 3).map((tier) => {
      if (singleJarPage && tier.quantity === 2) {
        return { ...tier, bundlePrice: 54, unitPrice: '$27.00', unitPriceAmount: 27 };
      }
      if (singleJarPage && tier.quantity === 6) {
        return { ...tier, bundlePrice: 132, unitPrice: '$22.00', unitPriceAmount: 22 };
      }
      if (singleJarPage && tier.quantity === 8) {
        return { ...tier, bundlePrice: 160, unitPrice: '$20.00', unitPriceAmount: 20 };
      }
      if (tier.quantity !== 1) return tier;
      const selectedPrice = getItemCount() === 1 ? getRegularSubtotal() : 0;
      const pagePrice = Number.parseFloat(bundleRoot?.closest('.cj-au-bundle-host')?.dataset.cjPagePrice) || 30;
      const price = selectedPrice || pagePrice;
      return { ...tier, bundlePrice: price, unitPrice: formatMoney(price), unitPriceAmount: price };
    });
  }

  function getSelectedTier() {
    return getAvailableTiers().find(({ quantity }) => quantity === selectedTierQuantity) || null;
  }

  function getNextTier(tier) {
    if (!tier) return null;
    return getAvailableTiers().find(({ quantity }) => quantity > tier.quantity) || null;
  }

  function getPricingTier(quantity) {
    if (isSingleJarPage() && quantity === 3) {
      return { quantity: 3, bundlePrice: 81, unitPrice: '$27.00', unitPriceAmount: 27 };
    }
    return getAvailableTiers().find((tier) => quantity === tier.quantity) || null;
  }

  function getBundlePrice(tier, quantity = getItemCount()) {
    if (!tier) return 0;
    if (isSingleJarPage() && tier.quantity === 2 && quantity === 3) return 81;
    return tier.bundlePrice;
  }

  function getTierBenefits(tier) {
    if (!tier || tier.quantity === 1) return [];

    const savingAmount = (tier.quantity * 30) - tier.bundlePrice;
    const benefits = [];

    if (tier.quantity === 8) benefits.push({ className: 'best', label: '★ Best value' });
    if (savingAmount > 0) benefits.push({ className: 'saving', label: `Save ${formatMoney(savingAmount)}+` });

    return benefits;
  }

  function isTierReady(tier, quantity) {
    return Boolean(tier && (quantity === tier.quantity
      || (isSingleJarPage() && tier.quantity === 2 && quantity === 3)));
  }

  function getItemCount() {
    return [...bundleRoot.querySelectorAll('.essenify-mam-qty-val')].reduce((total, value) => {
      const quantity = Number.parseInt(value.textContent, 10);
      return total + (Number.isFinite(quantity) ? quantity : 0);
    }, 0);
  }

  function promoteTierToFitSelection() {
    if (selectionRebaseInProgress) return;

    const count = getItemCount();
    const selectedTier = getSelectedTier();
    if (isSingleJarPage() && selectedTier?.quantity === 4 && lastCount === 4 && count === 3) {
      selectedTierQuantity = 2;
      bundleRoot.dataset.cjSelectedTier = '2';
      return;
    }
    const tierLimit = isSingleJarPage() && selectedTier?.quantity === 2 ? 3 : selectedTier?.quantity;
    if (!selectedTier || count <= tierLimit) return;

    const nextTier = getAvailableTiers().find((tier) => tier.quantity >= count);
    if (!nextTier) return;

    selectedTierQuantity = nextTier.quantity;
    tierPanelCollapsed = false;
    bundleRoot.dataset.cjSelectedTier = String(nextTier.quantity);
  }

  function formatMoney(value) {
    return `$${Number.isInteger(value) ? value : value.toFixed(2)}`;
  }

  function setAttributeIfChanged(element, name, value) {
    if (element.getAttribute(name) !== value) element.setAttribute(name, value);
  }

  async function getSelectedVariants() {
    const selectedCards = [...bundleRoot.querySelectorAll('.essenify-mam-product-card')]
      .map((card) => ({
        flavour: getRetailFlavour(card),
        productLink: card.querySelector('a[href*="/products/"]'),
        quantity: Number.parseInt(card.querySelector('.essenify-mam-qty-val')?.textContent, 10) || 0,
      }))
      .filter(({ quantity }) => quantity > 0);

    return Promise.all(selectedCards.map(async ({ flavour, productLink, quantity }) => {
      if (!flavour || !productLink) {
        throw new Error('A selected jar is not an active AU retail single. Please reload and try again.');
      }
      const productUrl = new URL(productLink.href, window.location.origin);
      const response = await fetch(`${productUrl.pathname}.js`, {
        headers: { Accept: 'application/json' },
        cache: 'no-store',
      });

      if (!response.ok) {
        throw new Error(`Unable to resolve ${productLink.textContent.trim()} before adding it to the cart.`);
      }

      const product = await response.json();
      const variant = Array.isArray(product.variants) && product.variants.length === 1
        ? product.variants[0]
        : null;

      if (!variant?.id) {
        throw new Error(`Unable to identify the selected variant for ${product.title || productLink.textContent.trim()}.`);
      }
      if (String(product.id) !== flavour.productId || String(variant.id) !== flavour.variantId) {
        throw new Error(`${flavour.name} no longer matches the AU retail single. Please reload and try again.`);
      }
      if (!variant.available || product.available === false) {
        throw new Error(`${product.title || productLink.textContent.trim()} has sold out. Please remove it and choose another jar.`);
      }

      return {
        variant_id: variant.id.toString(),
        quantity,
        priceCents: Number(variant.price),
      };
    }));
  }

  async function getCartItems(container) {
    const apiResponse = typeof mamApiResponse === 'object' && mamApiResponse
      ? mamApiResponse
      : null;

    if (!apiResponse?.id) return [];

    const originalBundleId = apiResponse.id.toString();
    const bundleId = `${originalBundleId}_${Date.now().toString(36)}`;
    const mamItems = await getSelectedVariants();
    const totalQuantity = mamItems.reduce((total, item) => total + Number(item.quantity || 0), 0);
    const pricingTier = getPricingTier(totalQuantity);
    const regularSubtotal = mamItems.reduce(
      (total, item) => total + (item.quantity * item.priceCents / 100),
      0,
    );
    const bundlePrice = getBundlePrice(pricingTier, totalQuantity);
    const discountPercentage = pricingTier && regularSubtotal > 0
      ? Math.max((1 - (bundlePrice / regularSubtotal)) * 100, 0)
      : 0;
    const groupedItems = {};

    mamItems.forEach((item) => {
      const variantId = Number.parseInt(item.variant_id, 10);
      const quantity = Number(item.quantity || 0);

      if (!variantId || !Number.isFinite(quantity) || quantity <= 0) return;
      groupedItems[variantId] = (groupedItems[variantId] || 0) + quantity;
    });

    return Object.entries(groupedItems).map(([variantId, quantity]) => {
      const cartItem = {
        id: Number.parseInt(variantId, 10),
        quantity,
      };

      if (pricingTier?.quantity === 1) return cartItem;

      return {
        ...cartItem,
        properties: {
          _essenify_mam_bundle_id: bundleId,
          _essenify_mam_original_bundle_id: originalBundleId,
          _essenify_mam_parent_variant_id: `gid://shopify/ProductVariant/${(container.dataset.parentVariant || '').replace(/[^\d]/g, '')}`,
          _essenify_mam_discount_percentage: discountPercentage,
          _essenify_mam_per_bundle_qty: quantity,
          _essenify_mam_items: JSON.stringify(
            mamItems.map(({ variant_id, quantity }) => ({ variant_id, quantity })),
          ),
        },
      };
    });
  }

  function showCartError(submit, message) {
    let error = bundleRoot.querySelector('.cj-bundle-cart-error');

    if (!error) {
      error = document.createElement('p');
      error.className = 'cj-bundle-cart-error';
      error.setAttribute('role', 'alert');
      submit.after(error);
    }

    error.textContent = message || 'We could not add your jars. Please try again.';
  }

  async function handleCartSubmit(event) {
    event.preventDefault();

    const submit = event.currentTarget;
    const container = bundleRoot.querySelector('#essenify-mam-app-block');
    const selectedTier = getSelectedTier();
    const cartDrawer = document.querySelector('cart-drawer');

    if (
      !container
      || !selectedTier
      || !isTierReady(selectedTier, getItemCount())
      || !cartDrawer?.getSectionsToRender
      || submit.dataset.cjCartSubmitting === 'true'
    ) return;

    const originalText = submit.innerHTML;
    submit.dataset.cjCartSubmitting = 'true';
    submit.disabled = true;
    submit.setAttribute('aria-busy', 'true');
    submit.setAttribute('aria-disabled', 'true');
    submit.innerHTML = '<span class="mam-loader" aria-hidden="true"></span><span class="visually-hidden">Adding to cart</span>';
    bundleRoot.querySelector('.cj-bundle-cart-error')?.remove();

    try {
      const items = await getCartItems(container);

      if (!items.length) {
        throw new Error('No selected jars were available to add to the cart.');
      }

      // Appstle's global cart interceptor uses this flag to leave other bundle requests intact.
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js?ignorecheck=true&appstle=true`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items,
          sections: cartDrawer.getSectionsToRender().map(({ id }) => id),
          sections_url: window.location.pathname,
        }),
      });

      if (!response.ok) {
        const responseText = await response.text();
        let customerMessage;

        try {
          const responseData = JSON.parse(responseText);
          customerMessage = responseData.description || responseData.message;
        } catch (error) {
          customerMessage = null;
        }

        const cartError = new Error(`Cart request failed with status ${response.status}: ${responseText}`);
        cartError.customerMessage = customerMessage;
        throw cartError;
      }

      const responseData = await response.json();

      if (!Array.isArray(responseData.items) || !responseData.items.length || !responseData.sections) {
        throw new Error('Shopify returned no rendered cart drawer.');
      }

      cartDrawer.setActiveElement?.(submit);
      cartDrawer.classList.remove('is-empty');
      cartDrawer.renderContents(responseData);

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS === 'object') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'essenify-au-bundle',
          cartData: responseData,
        });
      }
    } catch (error) {
      console.error('Error adding bundle to cart:', error);
      showCartError(submit, error.customerMessage || error.message);
    } finally {
      if (!submit.isConnected) return;

      submit.innerHTML = originalText;
      submit.disabled = false;
      submit.removeAttribute('aria-busy');
      delete submit.dataset.cjCartSubmitting;
      queueRender();
    }
  }

  function ensureCartSubmit() {
    const submit = bundleRoot?.querySelector('#essenify-mam-submit');

    if (
      !submit
      || submit.dataset.cjCartReady === 'true'
      || !bundleRoot.querySelector('.essenify-mam-product-card')
    ) return;

    const replacement = submit.cloneNode(true);
    replacement.dataset.cjCartReady = 'true';
    replacement.addEventListener('click', handleCartSubmit);
    submit.replaceWith(replacement);
  }

  function getCardRegularPrice(card) {
    if (card.dataset.cjRegularPrice) return Number(card.dataset.cjRegularPrice);
    const priceText = card.querySelector('.essenify-mam-product-price')?.textContent || '';
    const amount = Number.parseFloat(priceText.match(/\d+(?:\.\d{1,2})?/)?.[0] || '');
    if (Number.isFinite(amount) && amount > 0) {
      card.dataset.cjRegularPrice = String(amount);
      return amount;
    }
    return 0;
  }

  function getRegularSubtotal() {
    return [...bundleRoot.querySelectorAll('.essenify-mam-product-card')].reduce((total, card) => {
      const quantity = Number.parseInt(card.querySelector('.essenify-mam-qty-val')?.textContent, 10) || 0;
      return total + (quantity * getCardRegularPrice(card));
    }, 0);
  }

  function ensureSingleTierChoice(row) {
    if (row.querySelector('[data-cj-synthetic-single]')) return row;
    const single = document.createElement('div');
    single.className = 'essenify-mam-rule-block';
    single.dataset.cjSyntheticSingle = 'true';
    const badge = document.createElement('span');
    badge.className = 'essenify-mam-rule-badge';
    single.append(badge);
    row.prepend(single);
    return row;
  }

  function ensureTierOptionWrappers(row) {
    [...row.children].forEach((child) => {
      if (!child.classList.contains('essenify-mam-rule-block')) return;

      const option = document.createElement('div');
      option.className = 'cj-bundle-tier-option';
      child.before(option);
      option.append(child);
    });
  }

  function updateTierChoices() {
    const selectedTier = getSelectedTier();
    bundleRoot.querySelectorAll('.essenify-mam-rules-row').forEach((row) => {
      ensureSingleTierChoice(row);
      ensureTierOptionWrappers(row);
      setAttributeIfChanged(row, 'role', 'radiogroup');
      setAttributeIfChanged(row, 'aria-label', isLaunchProductPage() ? 'Choose one jar or a bundle' : 'Choose your box size');

      const availableTiers = getAvailableTiers();

      row.querySelectorAll('.essenify-mam-rule-block').forEach((block, index) => {
        const option = block.closest('.cj-bundle-tier-option');
        const hiddenThreePack = isSingleJarPage() && index === 2;
        if (option) option.hidden = hiddenThreePack;
        if (hiddenThreePack) {
          setAttributeIfChanged(block, 'aria-hidden', 'true');
          setAttributeIfChanged(block, 'tabindex', '-1');
          return;
        }
        if (option?.hidden) option.hidden = false;

        if (block.hasAttribute('aria-hidden')) block.removeAttribute('aria-hidden');
        const tier = availableTiers[index - Number(isSingleJarPage() && index > 2)];
        if (!tier) return;

        const isSelected = selectedTier?.quantity === tier.quantity;
        block.classList.remove('active', 'cj-bundle-tier-next', 'cj-bundle-tier-unlocked');
        block.classList.toggle('cj-bundle-tier-selected', isSelected);
        block.dataset.cjTierQuantity = String(tier.quantity);
        setAttributeIfChanged(block, 'role', 'radio');
        setAttributeIfChanged(block, 'tabindex', '0');
        setAttributeIfChanged(block, 'aria-checked', String(isSelected));
        setAttributeIfChanged(block, 'aria-expanded', String(isSelected && !tierPanelCollapsed));
        setAttributeIfChanged(block, 'aria-controls', 'essenify-mam-products-grid');
        setAttributeIfChanged(
          block,
          'aria-label',
          `${tier.quantity === 1 ? '1 Jar' : tier.quantity === 2 ? (isSingleJarPage() ? '2 Jars, with an optional third' : '2 Jars') : `${tier.quantity} Pack`}, ${tier.unitPrice} per jar, ${formatMoney(isSelected ? getBundlePrice(tier) : tier.bundlePrice)} total${tier.quantity === 8 ? ', best value' : ''}`,
        );

        if (block.dataset.cjTierFormatted !== 'true') {
          [...block.childNodes]
            .filter((node) => node.nodeType === Node.TEXT_NODE)
            .forEach((node) => node.remove());

          const name = document.createElement('span');
          name.className = 'cj-bundle-tier-name';
          name.textContent = tier.quantity === 1 ? '1 Jar' : tier.quantity === 2 ? '2 Jars' : `${tier.quantity} Pack`;
          block.append(name);

          const subtitle = document.createElement('span');
          subtitle.className = 'cj-bundle-tier-subtitle';
          subtitle.textContent = tier.quantity === 1
            ? '350g'
            : isSingleJarPage() && tier.quantity === 2 ? 'Choose 2 or 3' : 'Mix & Match';
          block.append(subtitle);

          const chevron = document.createElement('span');
          chevron.className = 'cj-bundle-tier-chevron';
          chevron.setAttribute('aria-hidden', 'true');
          block.append(chevron);
          block.dataset.cjTierFormatted = 'true';
        }

        const badge = block.querySelector('.essenify-mam-rule-badge');
        const displayedPrice = isSelected ? getBundlePrice(tier) : tier.bundlePrice;
        if (badge && badge.textContent !== `${formatMoney(displayedPrice)} total`) {
          badge.textContent = `${formatMoney(displayedPrice)} total`;
        }

        let unitPrice = block.querySelector(':scope > .cj-bundle-tier-unit-price');

        if (!unitPrice) {
          unitPrice = document.createElement('span');
          unitPrice.className = 'cj-bundle-tier-unit-price';
          block.append(unitPrice);
        }

        const label = `${tier.unitPrice.replace('.00', '')}/JAR`;
        if (unitPrice.textContent !== label) unitPrice.textContent = label;

        let promotions = block.querySelector(':scope > .cj-bundle-tier-promotions');
        if (!promotions) {
          promotions = document.createElement('span');
          promotions.className = 'cj-bundle-tier-promotions';
          block.append(promotions);
        }

        const promotionMarkup = getTierBenefits(tier)
          .map(({ className, label }) => `<span class="cj-bundle-tier-promo cj-bundle-tier-promo--${className}">${label}</span>`)
          .join('');
        if (promotions.innerHTML !== promotionMarkup) promotions.innerHTML = promotionMarkup;
        promotions.hidden = !promotionMarkup;

        option?.classList.toggle('cj-bundle-tier-option-selected', isSelected);
        option?.classList.toggle('cj-bundle-tier-option-collapsed', isSelected && tierPanelCollapsed);
        if (option) {
          option.style.setProperty('border-color', isSelected ? '#154b2a' : '#d4dcd6', 'important');
          option.style.setProperty(
            'background',
            isSelected ? 'linear-gradient(135deg, #f8fcf8 0%, #f1f8f2 100%)' : '#ffffff',
            'important',
          );
          option.style.setProperty('color', '#111815', 'important');
          option.style.setProperty('box-shadow', '0 5px 15px rgba(21, 49, 32, 0.07)', 'important');
        }
        block.style.setProperty('color', '#111815', 'important');
        block.querySelector('.cj-bundle-tier-name')?.style.setProperty('color', '#111815', 'important');
        block.querySelector('.cj-bundle-tier-chevron')?.style.setProperty('color', '#111815', 'important');
        unitPrice.style.setProperty('color', '#154b2a', 'important');
        badge?.style.setProperty('color', '#59625d', 'important');
      });
    });
  }

  function ensureStepHeadings() {
    const app = bundleRoot.querySelector('#essenify-mam-app-block');
    const mobileRules = bundleRoot.querySelector('.essenify-mam-rules-mobile');
    const products = bundleRoot.querySelector('#essenify-mam-products-grid');
    if (!app || !mobileRules || !products) return;

    app.querySelector('.cj-bundle-step--tier')?.remove();

    if (!app.querySelector('.cj-bundle-step--flavours')) {
      const heading = document.createElement('div');
      heading.className = 'cj-bundle-step cj-bundle-step--flavours';
      heading.innerHTML = `
        <span class="cj-bundle-step-number" aria-hidden="true">2</span>
        <div>
          <h2>Choose your flavours</h2>
          <p class="cj-bundle-flavour-status" aria-live="polite"></p>
        </div>
      `;
      products.before(heading);
    }
  }

  function updateTierNudge() {
    const products = bundleRoot.querySelector('#essenify-mam-products-grid');
    if (!products) return;

    let nudge = bundleRoot.querySelector('.cj-bundle-tier-nudge');
    if (!nudge) {
      nudge = document.createElement('aside');
      nudge.className = 'cj-bundle-tier-nudge';
      nudge.setAttribute('role', 'note');
      products.after(nudge);
    }

    nudge.dataset.cjPromptVisible = 'false';
    nudge.hidden = true;
  }

  function updateTierUpsell() {
    const products = bundleRoot.querySelector('#essenify-mam-products-grid');
    if (!products) return;

    let upsell = bundleRoot.querySelector('.cj-bundle-next-tier-upsell');
    if (!upsell) {
      upsell = document.createElement('aside');
      upsell.className = 'cj-bundle-next-tier-upsell';
      upsell.setAttribute('role', 'note');
      bundleRoot.querySelector('.cj-bundle-tier-nudge')?.after(upsell);
    }

    upsell.dataset.cjUpsellVisible = 'false';
    upsell.hidden = true;
  }

  function ensureAccordionPanel() {
    const app = bundleRoot.querySelector('#essenify-mam-app-block');
    const row = bundleRoot.querySelector('.essenify-mam-rules-mobile');
    const flavourHeading = bundleRoot.querySelector('.cj-bundle-step--flavours');
    const products = bundleRoot.querySelector('#essenify-mam-products-grid');
    const nudge = bundleRoot.querySelector('.cj-bundle-tier-nudge');
    const upsell = bundleRoot.querySelector('.cj-bundle-next-tier-upsell');
    const sidebar = bundleRoot.querySelector('.essenify-mam-sidebar');
    if (
      !app
      || !row
      || !flavourHeading
      || !products
      || !nudge
      || !upsell
      || !sidebar
      || !products.querySelector('.essenify-mam-product-card')
    ) return;

    row.classList.add('cj-bundle-tier-list');
    app.classList.add('cj-bundle-accordion-ready');

    const options = [...row.querySelectorAll(':scope > .cj-bundle-tier-option')];
    options.forEach((option, index) => {
      option.style.order = String((index + 1) * 10);
    });

    const selectedIndex = options.findIndex((option) => option.classList.contains('cj-bundle-tier-option-selected'));
    const isOpen = selectedIndex >= 0 && !tierPanelCollapsed;
    const panelOrder = ((selectedIndex + 1) * 10) + 1;
    const panelParts = [flavourHeading, products, nudge, upsell, sidebar];

    panelParts.forEach((part, index) => {
      part.classList.add('cj-bundle-accordion-panel-part');
      part.style.order = String(panelOrder + index);
      const isHiddenNudge = part === nudge && nudge.dataset.cjPromptVisible !== 'true';
      const isHiddenUpsell = part === upsell && upsell.dataset.cjUpsellVisible !== 'true';
      part.hidden = !isOpen || isHiddenNudge || isHiddenUpsell;
    });

    app.classList.toggle('cj-bundle-accordion-open', isOpen);
  }

  function getCurrentProductCard() {
    if (!isLaunchProductPage()) return null;

    const path = window.location.pathname;
    return [...bundleRoot.querySelectorAll('.essenify-mam-product-card')].find((card) => {
      const href = card.querySelector('.essenify-mam-product-title a')?.getAttribute('href') || '';
      return href && path.startsWith(href);
    }) || null;
  }

  function getCurrentProductName() {
    const link = getCurrentProductCard()?.querySelector('.essenify-mam-product-title a');
    return link?.textContent.trim() || 'this jar';
  }

  function getSelectedProductName() {
    const card = [...bundleRoot.querySelectorAll('.essenify-mam-product-card')].find((candidate) => {
      const quantity = Number.parseInt(candidate.querySelector('.essenify-mam-qty-val')?.textContent, 10) || 0;
      return quantity > 0;
    });
    return card?.querySelector('.essenify-mam-product-title a')?.textContent.trim() || getCurrentProductName();
  }

  function resetProductQuantities(onComplete) {
    const reduceNextQuantity = () => {
      const card = [...bundleRoot.querySelectorAll('.essenify-mam-product-card')].find((candidate) => {
        const quantity = Number.parseInt(candidate.querySelector('.essenify-mam-qty-val')?.textContent, 10) || 0;
        return quantity > 0 && candidate.querySelector('.essenify-mam-qty-minus');
      });

      if (!card) {
        onComplete?.();
        return;
      }

      card.querySelector('.essenify-mam-qty-minus').click();
      window.requestAnimationFrame(reduceNextQuantity);
    };

    reduceNextQuantity();
  }

  function seedLaunchProductSelection() {
    const selectedTier = getSelectedTier();
    if (!selectedTier || !isLaunchProductPage()) return;

    const currentCard = getCurrentProductCard();
    const add = currentCard?.querySelector('[data-cj-qty-action="plus"], .essenify-mam-btn-add');
    if (add && !add.disabled) add.click();
  }

  function updateProductControls() {
    const selectedTier = getSelectedTier();
    const count = getItemCount();
    const isLocked = !selectedTier;
    const products = bundleRoot.querySelector('#essenify-mam-products-grid');
    const status = bundleRoot.querySelector('.cj-bundle-flavour-status');
    const flavourHeading = bundleRoot.querySelector('.cj-bundle-step--flavours h2');

    products?.classList.toggle('cj-bundle-products-locked', isLocked);

    if (flavourHeading) {
      const headingText = 'Choose your flavours';
      if (flavourHeading.textContent !== headingText) flavourHeading.textContent = headingText;
    }

    if (status) {
      status.textContent = isLocked
        ? 'Choose a box size above to unlock the flavour controls.'
        : isTierReady(selectedTier, count)
          ? isSingleJarPage() && selectedTier.quantity === 2 && count === 2
            ? '2 jars selected · $27 per jar · add a third for $27, or check out now.'
            : `${count} ${count === 1 ? 'jar' : 'jars'} selected · ${selectedTier.unitPrice} per jar · ready to add.`
          : `${count} of ${selectedTier.quantity} selected · use + and − to mix any way you like.`;
    }

    bundleRoot.querySelectorAll('.essenify-mam-product-card').forEach((card) => {
      card.hidden = false;
      card.classList.toggle('cj-bundle-card-locked', isLocked);
      card.classList.remove('cj-bundle-single-card');

      const link = card.querySelector('.essenify-mam-product-title a');
      const flavour = getRetailFlavour(card);
      if (flavour && link?.textContent !== flavour.name) link.textContent = flavour.name;
      const image = card.querySelector('.essenify-mam-product-image');
      const retailImageAlt = flavour ? `${flavour.name} 350g single jar` : '';
      if (image && retailImageAlt && image.alt !== retailImageAlt) image.alt = retailImageAlt;

      const isAvailable = !isCardUnavailable(card);
      card.classList.toggle('cj-bundle-product-unavailable', !isAvailable);
      let soldOutLabel = card.querySelector('.cj-bundle-sold-out');
      if (!isAvailable && !soldOutLabel) {
        soldOutLabel = document.createElement('span');
        soldOutLabel.className = 'cj-bundle-sold-out';
        soldOutLabel.textContent = 'Sold out';
        card.querySelector('.essenify-mam-product-title')?.append(soldOutLabel);
      } else if (isAvailable && soldOutLabel) {
        soldOutLabel.remove();
      }

      card.querySelectorAll('.essenify-mam-btn-add').forEach((button) => {
        if (!button.hasAttribute('data-cj-native-disabled')) {
          button.dataset.cjNativeDisabled = String(button.disabled);
        }

        if (!button.closest('.cj-bundle-zero-qty')) {
          const wrapper = document.createElement('div');
          wrapper.className = 'cj-bundle-zero-qty';
          wrapper.innerHTML = '<button type="button" class="cj-bundle-zero-minus" disabled aria-hidden="true">−</button><span class="cj-bundle-zero-value">0</span>';
          button.before(wrapper);
          wrapper.append(button);
        }

        const shouldDisable = button.dataset.cjNativeDisabled === 'true'
          || !isAvailable
          || isLocked
          || count >= maximumQuantity;
        if (button.disabled !== shouldDisable) button.disabled = shouldDisable;
        setAttributeIfChanged(button, 'aria-disabled', String(shouldDisable));
        setAttributeIfChanged(button, 'aria-label', `Add one ${link?.textContent.trim() || 'jar'}`);
        if (button.textContent !== '+') button.textContent = '+';
      });

      card.querySelectorAll('.essenify-mam-qty-plus').forEach((button) => {
        if (!button.hasAttribute('data-cj-native-disabled')) {
          button.dataset.cjNativeDisabled = String(button.disabled);
        }

        const shouldDisable = button.dataset.cjNativeDisabled === 'true'
          || !isAvailable
          || isLocked
          || count >= maximumQuantity;
        if (button.disabled !== shouldDisable) button.disabled = shouldDisable;
        setAttributeIfChanged(button, 'aria-disabled', String(shouldDisable));
      });

      card.querySelectorAll('[data-cj-qty-action="minus"]').forEach((button) => {
        const quantity = Number.parseInt(card.querySelector('.essenify-mam-qty-val')?.textContent, 10) || 0;
        const shouldDisable = quantity <= 0;
        if (button.disabled !== shouldDisable) button.disabled = shouldDisable;
        setAttributeIfChanged(button, 'aria-disabled', String(shouldDisable));
      });

      card.querySelector('.cj-bundle-single-selected')?.remove();
    });
  }

  function selectTier(quantity, { preserveSelection = false, scroll = true } = {}) {
    const tier = getAvailableTiers().find((candidate) => candidate.quantity === quantity);
    if (!tier) return;

    const tierChanged = selectedTierQuantity !== tier.quantity;
    if (!tierChanged) {
      tierPanelCollapsed = !tierPanelCollapsed;
      queueRender();
      return;
    }

    const revision = ++selectionRevision;
    const shouldRebaseSelection = tierChanged && !preserveSelection;

    selectedTierQuantity = tier.quantity;
    tierPanelCollapsed = false;
    selectionRebaseInProgress = shouldRebaseSelection;
    celebratedTiers.clear();
    bundleRoot.dataset.cjSelectedTier = String(tier.quantity);
    queueRender();

    window.requestAnimationFrame(() => {
      if (shouldRebaseSelection) {
        resetProductQuantities(() => {
          if (revision !== selectionRevision || selectedTierQuantity !== tier.quantity) return;

          seedLaunchProductSelection();

          window.requestAnimationFrame(() => {
            if (revision !== selectionRevision || selectedTierQuantity !== tier.quantity) return;
            selectionRebaseInProgress = false;
            queueRender();
          });
        });
      }

      if (scroll) {
        bundleRoot.querySelector('.cj-bundle-tier-option-selected')?.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start',
        });
      }
    });
  }

  function handleBundleClick(event) {
    if (
      bundleRoot.querySelector('#essenify-mam-submit')?.dataset.cjCartSubmitting === 'true'
      && event.target.closest('.essenify-mam-rule-block, .essenify-mam-btn-add, .essenify-mam-qty-plus, .essenify-mam-qty-minus')
    ) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    const submitButton = event.target.closest('#essenify-mam-submit');
    if (submitButton && bundleRoot.contains(submitButton)) {
      const selectedTier = getSelectedTier();
      const selectedQuantity = getItemCount();
      const container = bundleRoot.querySelector('#essenify-mam-app-block');

      if (container && isTierReady(selectedTier, selectedQuantity)) {
        const regularSubtotal = getRegularSubtotal();
        const discountPercentage = regularSubtotal > 0
          ? Math.max((1 - (getBundlePrice(selectedTier) / regularSubtotal)) * 100, 0)
          : 0;

        // Keep the app's visible percentage aligned with the actual AU jar mix.
        container.dataset.currentDiscount = String(discountPercentage);
      }
    }

    const upsellButton = event.target.closest('.cj-bundle-next-tier-upsell-button');
    if (upsellButton && bundleRoot.contains(upsellButton)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      selectTier(6, { preserveSelection: true });
      return;
    }

    const tierBlock = event.target.closest('.essenify-mam-rule-block');
    if (tierBlock && bundleRoot.contains(tierBlock)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      selectTier(Number.parseInt(tierBlock.dataset.cjTierQuantity, 10));
      return;
    }

    const increment = event.target.closest('.essenify-mam-btn-add, .essenify-mam-qty-plus');
    if (!increment) return;

    if (selectionRebaseInProgress) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    const selectedTier = getSelectedTier();
    if (!selectedTier) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    const count = getItemCount();
    if (count >= maximumQuantity) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    const nextTier = getNextTier(selectedTier);
    const tierLimit = isSingleJarPage() && selectedTier.quantity === 2 ? 3 : selectedTier.quantity;
    if (nextTier && count + 1 > tierLimit) {
      selectTier(nextTier.quantity, { preserveSelection: true, scroll: false });
    }
  }

  function handleBundleKeydown(event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const tierBlock = event.target.closest('.essenify-mam-rule-block');
    if (!tierBlock || !bundleRoot.contains(tierBlock)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    if (bundleRoot.querySelector('#essenify-mam-submit')?.dataset.cjCartSubmitting === 'true') return;
    selectTier(Number.parseInt(tierBlock.dataset.cjTierQuantity, 10));
  }

  function celebrateTier(sidebar, quantity) {
    if (celebratedTiers.has(quantity)) return;

    celebratedTiers.add(quantity);
    window.clearTimeout(celebrationTimer);
    sidebar.classList.remove('cj-bundle-celebrate');
    void sidebar.offsetWidth;
    sidebar.classList.add('cj-bundle-celebrate');

    celebrationTimer = window.setTimeout(() => {
      if (sidebar.isConnected) sidebar.classList.remove('cj-bundle-celebrate');
    }, 1100);
  }

  function updateCardUnitPrices() {
    const tier = getSelectedTier();

    bundleRoot.querySelectorAll('.essenify-mam-product-card').forEach((card) => {
      const regularPrice = card.querySelector('.essenify-mam-product-price');
      if (!regularPrice) return;

      const regularPriceAmount = getCardRegularPrice(card);
      if (!regularPriceAmount) return;
      const regularPriceText = `$${regularPriceAmount.toFixed(2)}`;

      const regularPriceLabel = `Regular price ${regularPriceText}`;
      if (regularPrice.getAttribute('aria-label') !== regularPriceLabel) {
        regularPrice.setAttribute('aria-label', regularPriceLabel);
      }

      let bundlePrice = card.querySelector('.cj-bundle-card-unit-price');

      if (!bundlePrice) {
        bundlePrice = document.createElement('div');
        bundlePrice.className = 'cj-bundle-card-unit-price';

        const priceValue = document.createElement('span');
        priceValue.className = 'cj-bundle-card-unit-price-value';

        const tierLabel = document.createElement('span');
        tierLabel.className = 'cj-bundle-card-unit-price-tier';

        bundlePrice.append(priceValue, tierLabel);
        regularPrice.after(bundlePrice);
      }

      if (bundlePrice.className !== 'cj-bundle-card-unit-price') {
        bundlePrice.className = 'cj-bundle-card-unit-price';
      }
      if (bundlePrice.hidden) bundlePrice.hidden = false;

      const priceValue = bundlePrice.querySelector('.cj-bundle-card-unit-price-value');
      const tierLabel = bundlePrice.querySelector('.cj-bundle-card-unit-price-tier');
      const priceText = tier
        ? `${tier.quantity === 1 ? regularPriceText : tier.unitPrice} / jar`
        : `${regularPriceText} regular price`;
      const tierText = tier
        ? tier.quantity === 1
          ? '1 Jar price'
          : tier.quantity === 2
            ? '2 Jars price'
            : `${tier.quantity} Pack price`
        : 'Choose a box size to see bundle pricing';

      if (priceValue.textContent !== priceText) priceValue.textContent = priceText;
      if (tierLabel.textContent !== tierText) tierLabel.textContent = tierText;
    });
  }

  function ensureSummaryGuide(sidebar) {
    let guide = sidebar.querySelector('.cj-bundle-summary-guide');

    if (!guide) {
      guide = document.createElement('div');
      guide.className = 'cj-bundle-summary-guide';
      guide.setAttribute('aria-live', 'polite');
      guide.innerHTML = `
        <p class="cj-bundle-summary-message"></p>
        <div class="cj-bundle-summary-progress" role="progressbar">
          <span class="cj-bundle-summary-progress-fill"></span>
        </div>
      `;
      sidebar.querySelector('.essenify-mam-sidebar-header')?.after(guide);
    }

    return guide;
  }

  function updateSummary() {
    const sidebar = bundleRoot.querySelector('.essenify-mam-sidebar');
    const title = bundleRoot.querySelector('#essenify-mam-summary-title');
    const priceLabel = bundleRoot.querySelector('.essenify-mam-price-label');
    const priceValues = bundleRoot.querySelector('#essenify-mam-price-display');
    const submit = bundleRoot.querySelector('#essenify-mam-submit');
    const toggle = bundleRoot.querySelector('#essenify-mam-drawer-toggle');

    if (!sidebar || !title || !priceLabel || !priceValues || !submit) return;

    const count = getItemCount();
    const selectedTier = getSelectedTier();
    const targetQuantity = selectedTier?.quantity === 2 && isSingleJarPage() && getItemCount() === 3
      ? 3
      : selectedTier?.quantity || getAvailableTiers()[0].quantity;
    const regularSubtotal = getRegularSubtotal();
    const isReady = isTierReady(selectedTier, count);
    const guide = ensureSummaryGuide(sidebar);
    const message = guide.querySelector('.cj-bundle-summary-message');
    const progress = guide.querySelector('.cj-bundle-summary-progress');
    const progressFill = guide.querySelector('.cj-bundle-summary-progress-fill');

    let titleText;
    let messageText;
    let buttonText;

    if (!selectedTier) {
      titleText = isLaunchProductPage() ? 'Choose your purchase option' : 'Start with your box size';
      messageText = isLaunchProductPage()
        ? 'Choose one jar, or select a bundle to mix any available flavours.'
        : `Choose ${isSingleJarPage() ? '1, 2, 4, 6 or 8' : '1, 2, 3, 4, 6 or 8'} jars above, then mix your flavours.`;
      buttonText = isLaunchProductPage() ? 'Choose an option' : 'Choose a box size';
    } else if (isReady) {
      titleText = selectedTier.quantity === 1
        ? `✓ ${getSelectedProductName()} is ready`
        : selectedTier.quantity === 2
          ? `✓ Your ${count} Jars are ready`
          : `✓ Your ${selectedTier.quantity} Pack is ready`;
      messageText = isSingleJarPage() && selectedTier.quantity === 2 && count === 2
        ? '2 selected · $27 per jar · add a third for $27, or check out now.'
        : `${count} selected · ${selectedTier.unitPrice} per jar`;
      buttonText = selectedTier.quantity === 1 && count === 1
          ? `Add 1 jar to Cart · ${formatMoney(getBundlePrice(selectedTier))}`
        : selectedTier.quantity === 2
          ? `Add ${count} Jars to Cart · ${formatMoney(getBundlePrice(selectedTier))}`
          : `Add ${selectedTier.quantity} Pack to Cart · ${formatMoney(getBundlePrice(selectedTier))}`;
    } else {
      const jarsRemaining = selectedTier.quantity - count;
      const jarLabel = jarsRemaining === 1 ? 'jar' : 'jars';
      titleText = `${count} of ${selectedTier.quantity} jars selected`;
      messageText = `Add ${jarsRemaining} more ${jarLabel} to complete your ${selectedTier.quantity} Pack.`;
      buttonText = `Add ${jarsRemaining} more ${jarLabel}`;
    }

    if (title.textContent !== titleText) title.textContent = titleText;
    if (message.textContent !== messageText) message.textContent = messageText;
    const canCheckout = isReady;
    if (submit.textContent.trim() !== buttonText) submit.textContent = buttonText;
    if (submit.dataset.cjCartSubmitting !== 'true' && submit.disabled === canCheckout) {
      submit.disabled = !canCheckout;
    }
    setAttributeIfChanged(submit, 'aria-disabled', String(!canCheckout));

    const shouldHideGuide = !selectedTier;
    if (guide.hidden !== shouldHideGuide) guide.hidden = shouldHideGuide;

    const progressMax = targetQuantity;
    const progressValue = Math.min(count, targetQuantity);
    const progressPercent = Math.min((progressValue / progressMax) * 100, 100);
    const progressLabel = `${progressValue} of ${progressMax} ${progressMax === 1 ? 'jar' : 'jars'} selected`;

    setAttributeIfChanged(progress, 'aria-valuemin', '0');
    setAttributeIfChanged(progress, 'aria-valuemax', String(progressMax));
    setAttributeIfChanged(progress, 'aria-valuenow', String(progressValue));
    setAttributeIfChanged(progress, 'aria-label', progressLabel);

    const progressWidth = `${progressPercent}%`;
    if (progressFill.style.width !== progressWidth) progressFill.style.width = progressWidth;

    sidebar.classList.toggle('cj-bundle-state-empty', !selectedTier);
    sidebar.classList.toggle('cj-bundle-state-progress', Boolean(selectedTier && !isReady));
    sidebar.classList.toggle('cj-bundle-state-ready', isReady);
    sidebar.classList.remove('cj-bundle-state-over');

    if (isReady && count !== lastCount) {
      celebrateTier(sidebar, count);
    } else if (!isReady && sidebar.classList.contains('cj-bundle-celebrate')) {
      window.clearTimeout(celebrationTimer);
      sidebar.classList.remove('cj-bundle-celebrate');
    }

    const priceLabelText = selectedTier
      ? selectedTier.quantity === 1
        ? 'Single jar total'
        : selectedTier.quantity === 2 ? `${count === 3 ? 3 : 2} Jars total` : `${selectedTier.quantity} Pack total`
      : 'Bundle total';
    if (priceLabel.textContent !== priceLabelText) priceLabel.textContent = priceLabelText;

    const originalPrice = priceValues.querySelector('.essenify-mam-original-price');
    const currentPrice = priceValues.querySelector('.essenify-mam-price-val');
    const originalPriceText = `$ ${regularSubtotal.toFixed(2)}`;
    const currentPriceAmount = getBundlePrice(selectedTier);
    const currentPriceText = `$ ${currentPriceAmount.toFixed(2)}`;

    if (originalPrice && originalPrice.textContent.trim() !== originalPriceText) {
      originalPrice.textContent = originalPriceText;
    }
    if (currentPrice && currentPrice.textContent.trim() !== currentPriceText) {
      currentPrice.textContent = currentPriceText;
    }

    let savings = priceValues.querySelector('.cj-bundle-summary-savings');

    if (!savings) {
      savings = document.createElement('span');
      savings.className = 'cj-bundle-summary-savings';
      priceValues.append(savings);
    }

    if (selectedTier && selectedTier.quantity > 1) {
      const savingAmount = Math.max(regularSubtotal - currentPriceAmount, 0);
      const savingsText = `Save ${formatMoney(savingAmount)}`;
      if (savings.textContent !== savingsText) savings.textContent = savingsText;
      if (savings.hidden) savings.hidden = false;
      savings.classList.remove('is-placeholder');
    } else {
      if (savings.textContent !== 'Price saving') savings.textContent = 'Price saving';
      if (savings.hidden) savings.hidden = false;
      savings.classList.add('is-placeholder');
    }

    if (toggle) {
      const drawerOpen = sidebar.classList.contains('drawer-open');
      setAttributeIfChanged(toggle, 'role', 'button');
      setAttributeIfChanged(toggle, 'tabindex', '0');
      setAttributeIfChanged(toggle, 'aria-label', drawerOpen ? 'Hide selected jars' : 'Show selected jars');
      setAttributeIfChanged(toggle, 'aria-expanded', String(drawerOpen));

      if (!toggle.dataset.cjKeyboardReady) {
        toggle.dataset.cjKeyboardReady = 'true';
        toggle.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          toggle.click();
        });
      }
    }

    lastCount = count;
  }

  function renderUnitPrices() {
    renderQueued = false;
    if (!bundleRoot?.isConnected) return;
    removeFaqifyAttribution();

    const retailCardsReady = sortRetailCards();
    promoteTierToFitSelection();
    ensureStepHeadings();
    updateTierChoices();
    positionLaunchProductBundle(retailCardsReady);
    updateTierNudge();
    updateTierUpsell();
    ensureAccordionPanel();
    updateProductControls();
    updateCardUnitPrices();
    updateSummary();
    ensureCartSubmit();
  }

  function queueRender() {
    if (renderQueued) return;
    renderQueued = true;
    window.requestAnimationFrame(renderUnitPrices);
  }

  function removeFaqifyAttribution() {
    document
      .querySelectorAll('.zify-faqs-published > img[src*="/1/0278/2999/3543/files/logo-small.png"]')
      .forEach((logo) => logo.remove());
  }

  function attachToBundle() {
    const roots = [...document.querySelectorAll('#essenify-mam-bundle-wrapper')];
    const currentRoot = roots.find((root) => root.querySelector('#essenify-mam-app-block')) || roots[0];
    if (!currentRoot) return false;

    roots.forEach((root) => {
      if (root !== currentRoot && !root.children.length) root.remove();
    });

    if (currentRoot === bundleRoot && bundleRoot.isConnected) return true;

    bundleObserver?.disconnect();
    bundleRoot = currentRoot;
    bundleSourceSection ||= currentRoot.closest('.shopify-section');
    bundleRoot.addEventListener('click', handleBundleClick, true);
    bundleRoot.addEventListener('keydown', handleBundleKeydown, true);

    renderUnitPrices();
    bundleObserver = new MutationObserver(queueRender);
    bundleObserver.observe(bundleRoot, {
      attributes: true,
      characterData: true,
      childList: true,
      subtree: true,
    });

    return true;
  }

  attachToBundle();

  const rootObserver = new MutationObserver(() => {
    removeFaqifyAttribution();
    const currentRoot = document.querySelector('#essenify-mam-bundle-wrapper');
    if (currentRoot && currentRoot !== bundleRoot) attachToBundle();
  });

  rootObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  const bootstrapTimer = window.setInterval(() => {
    const currentRoot = document.querySelector('#essenify-mam-bundle-wrapper');
    if (!currentRoot) return;

    if (currentRoot !== bundleRoot || !bundleRoot?.isConnected) {
      attachToBundle();
    } else {
      queueRender();
    }
  }, 250);

  window.setTimeout(() => window.clearInterval(bootstrapTimer), 15000);
})();
